import { render, staticRenderFns } from "./manageUserInfo.vue?vue&type=template&id=55972664&scoped=true&"
import script from "./manageUserInfo.vue?vue&type=script&lang=js&"
export * from "./manageUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./manageUserInfo.vue?vue&type=style&index=0&id=55972664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55972664",
  null
  
)

export default component.exports